import { MINUTE, DAY } from '../time'
import both from './assets/icon_both_bank_foreclosure.svg'

/**
 * Investor Onboarding codes and types
 */
export const IP_QUESTION_CODE = {
  INV_ONBOARDING_LOOKING_TO_BUY: 'INV_ONBOARDING_LOOKING_TO_BUY',
  INV_ONBOARDING_PRICE_INTEREST: 'INV_ONBOARDING_PRICE_INTEREST',
  INV_PREF_PROPERTY_TYPE: 'INV_PREF_PROPERTY_TYPE',
  INV_PREF_OCCUPIED_PROPERTIES: 'INV_PREF_OCCUPIED_PROPERTIES',
}

export const IP_QUESTION_LABEL = {
  INV_ONBOARDING_LOOKING_TO_BUY:
    'Which areas (up to 5) are you interested in exploring?',
  INV_ONBOARDING_PRICE_INTEREST: "What's your budget for a property?",
  INV_PREF_PROPERTY_TYPE: 'What type of property interests you?',
  INV_PREF_OCCUPIED_PROPERTIES: 'Would you buy occupied properties?',
}

export const IP_RESPONSE_TYPE = {
  GEO: 'GEO',
  LOOKUP: 'LOOKUP',
}

export const IP_API_VALUE_TYPE = {
  GEO: 'place_responses',
  LOOKUP: 'question_responses',
}

export const IP_API_VALUE_KEY = {
  GEO: 'place',
  LOOKUP: 'response_code',
}

/**
 * Questions Options
 */
export const PRICE_INTEREST_OPTIONS = [
  {
    key: 'default',
    value: '',
    text: 'Select',
    'data-elm-id': 'dropdown_default_option',
  },
  {
    key: '<$25K',
    value: 'PRICE_INTEREST_LESS_25K',
    text: '<$25K',
    'data-elm-id': 'price_less_than_25K',
  },
  {
    key: '$50K',
    value: 'PRICE_INTEREST_UPTO_50K',
    text: '$50K',
    'data-elm-id': 'price_up_to_50K',
  },
  {
    key: '$150K',
    value: 'PRICE_INTEREST_UPTO_150K',
    text: '$150K',
    'data-elm-id': 'price_up_to_150K',
  },
  {
    key: '$300K',
    value: 'PRICE_INTEREST_UPTO_300K',
    text: '$300K',
    'data-elm-id': 'price_up_to_300K',
  },
  {
    key: '$500K+',
    value: 'PRICE_INTEREST_500_PLUS',
    text: '$500K+',
    'data-elm-id': 'price_more_than_500K',
  },
]

export const PROPERTY_TYPE_OPTIONS = [
  {
    value: 'BANK_OWNED',
    label: 'Bank Owned',
    content:
      'A home that did not sell at the foreclosure sale and is now being sold by the mortgage lender.',
    'data-elm-id': 'bank_owned_type',
    icon: 'university',
  },
  {
    value: 'FORECLOSURE',
    label: 'Foreclosure',
    content:
      'A home that has a default mortgage and is being sold at auction to repay the debt.',
    'data-elm-id': 'foreclosure_type',
    icon: 'home',
  },
  {
    value: 'PRIVATE_SELLER',
    label: 'Private Seller',
    content:
      'A property, such as a home or land, sold directly by the owner with potential for flexible terms.',
    'data-elm-id': 'private_seller_type',
    icon: 'house-user',
  },
  {
    value: 'BOTH',
    label: 'Both',
    'data-elm-id': 'both_type',
    img: both,
  },
  {
    value: 'ALL',
    label: 'All',
    'data-elm-id': 'both_type',
    icon: 'house-building',
  },
]

export const OCCUPIED_PROPERTIES_OPTIONS = [
  {
    value: 'YES_OCCUPIED',
    label: 'Yes, Occupied and Vacant',
    content:
      'You can’t inspect the properties before buying. Expect to convert occupants to tenants or evict them.',
    'data-elm-id': 'yes_occupied',
    icon: 'users',
  },
  {
    value: 'NOT_OCCUPIED',
    label: 'No, Vacant Only',
    'data-elm-id': 'no_occupied',
    icon: 'sign',
  },
]

const GREETING_TITLE = 'Hi, %s! Let’s set you up'

/**
 * Onboarding default object
 */
export const IP_OBJECT = () => ({
  INV_ONBOARDING_LOOKING_TO_BUY: {
    code: IP_QUESTION_CODE.INV_ONBOARDING_LOOKING_TO_BUY,
    label: IP_QUESTION_LABEL.INV_ONBOARDING_LOOKING_TO_BUY,
    answer: {
      type: IP_RESPONSE_TYPE.GEO,
      value: null,
    },
  },
  INV_ONBOARDING_PRICE_INTEREST: {
    code: IP_QUESTION_CODE.INV_ONBOARDING_PRICE_INTEREST,
    label: IP_QUESTION_LABEL.INV_ONBOARDING_PRICE_INTEREST,
    answer: {
      type: IP_RESPONSE_TYPE.LOOKUP,
      value: null,
    },
    options: PRICE_INTEREST_OPTIONS,
  },
  INV_PREF_PROPERTY_TYPE: {
    title: GREETING_TITLE,
    hideBack: true,
    code: IP_QUESTION_CODE.INV_PREF_PROPERTY_TYPE,
    label: IP_QUESTION_LABEL.INV_PREF_PROPERTY_TYPE,
    answer: {
      type: IP_RESPONSE_TYPE.LOOKUP,
      value: null,
    },
    options: PROPERTY_TYPE_OPTIONS,
  },
  INV_PREF_OCCUPIED_PROPERTIES: {
    title: GREETING_TITLE,
    code: IP_QUESTION_CODE.INV_PREF_OCCUPIED_PROPERTIES,
    label: IP_QUESTION_LABEL.INV_PREF_OCCUPIED_PROPERTIES,
    answer: {
      type: IP_RESPONSE_TYPE.LOOKUP,
      value: null,
    },
    options: OCCUPIED_PROPERTIES_OPTIONS,
  },
})

export const AREA = 'AREA'
export const CITY = 'CITY'
export const COUNTY = 'COUNTY'
export const NOT_SPECIFIED = 'NOT_SPECIFIED'

/**
 * Onboarding location pills fields
 */
export const PLACE = 'place'
export const COUNTY_PROP_NAME = 'country_secondary_subdivision'
export const STATE_PROP_NAME = 'country_primary_subdivision'
export const CITY_PROP_NAME = 'municipality'
export const ZIP_PROP_NAME = 'postal_code'
export const LOCATION_TYPE = 'location_type_code'

/**
 * Investor Preference question fields
 */

export const YES_OCCUPIED = 'YES_OCCUPIED'
export const NOT_OCCUPIED = 'NOT_OCCUPIED'
export const BANK_OWNED = 'BANK_OWNED'
export const FORECLOSURE = 'FORECLOSURE'
export const BOTH = 'BOTH'
export const PRIVATE_SELLER = 'PRIVATE_SELLER'
export const ALL = 'ALL'

/**
 * Buyer Preference Nudge constants
 */
export const BUYER_PREFERENCES = 'BUYER_PREFERENCES'
export const NUDGE_CONSTANTS = () => ({
  REQUIRED_QUESTION_CODES: [
    'INV_ONBOARDING_LOOKING_TO_BUY',
    'INV_PREF_PROPERTY_TYPE',
    'INV_PREF_OCCUPIED_PROPERTIES',
  ],
  NUDGE_FIRST_DELAY: 2 * MINUTE, // 2 minutes after the first login
  NUDGE_DELAY: 7 * DAY, // 7 days after the user closes the modal
})
